"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _InfoIcon.default;
  }
});
Object.defineProperty(exports, "getInfoIconSlots", {
  enumerable: true,
  get: function () {
    return _InfoIcon.getInfoIconSlots;
  }
});
Object.defineProperty(exports, "infoIconClasses", {
  enumerable: true,
  get: function () {
    return _infoIconClasses.default;
  }
});
var _InfoIcon = _interopRequireWildcard(require("./InfoIcon"));
var _infoIconClasses = _interopRequireDefault(require("./infoIconClasses"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
